import type {Ref} from "vue"

export const useIframeStore = defineStore('iframe', {
  state: () => {
    const state: {
      top: Ref<number>,
      iframeTop: Ref<number>,
      screenHeight: Ref<number>,
      iframeHeight: Ref<number>,
    } = {
      top: ref(0),
      iframeTop: ref(0),
      screenHeight: ref(0),
      iframeHeight: ref(0),
    }
    return state
  },
  actions: {

  },
})
